import { type ComponentPropsWithoutRef } from "react";

import { Container } from "@/shared-web.ui/ui.container";

type AppContainerProps = {
  disablePadding?: boolean;
} & Omit<ComponentPropsWithoutRef<typeof Container>, "px">;
const AppContainer = (props: AppContainerProps) => {
  const { children, disablePadding, size = "4", ...containerProps } = props;
  return (
    <Container
      px={{
        initial: disablePadding ? "0" : "3",
        sm: "6",
        xs: "4",
      }}
      size={size}
      {...containerProps}
    >
      {children}
    </Container>
  );
};

export { AppContainer };
